// extracted by mini-css-extract-plugin
export var intro = "index-module--intro--0b876";
export var list = "index-module--list--fb407";
export var listItem = "index-module--listItem--06e6d";
export var listItemDescription = "index-module--listItemDescription--f3875";
export var listItemLink = "index-module--listItemLink--02c9e";
export var textCenter = "index-module--textCenter--4ece3";